/// FOURJS_START_COPYRIGHT(D,2024)
/// Property of Four Js*
/// (c) Copyright Four Js 2024, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

gbc.constants.requiredAPIs = {
  common: {
    navigator: ["clipboard", "serviceWorker", "geolocation", "mediaDevices"],
    window: ["fetch"],
    document: ["visibilityState"]
  },
  mobile: {
    navigator: ["contacts", "connection"],
    window: ["BarcodeDetector"]
  },
  desktop: {
    navigator: []
  },
  minimumRequiredVersions: {
    FGLGWS: "4.01.04",
    GAS: "4.00.00"
  }
};
